import { CompanyAPI } from '@api';

const getDriversGrades = async () => CompanyAPI.getDriversGrades()
  .then(({ data }) => data)
  .catch((error) => Promise.reject(error.response));

export { getDriversGrades };
